var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.34683,
    y: 2.38199,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    fill: "#FFD000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.34683,
    y: 2.38199,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    stroke: "#F9F9F9",
    strokeWidth: 3.19598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9851 18.6257L27.3871 17.8267C27.0915 17.6829 26.7239 17.7947 26.5801 18.0903C26.4283 18.394 26.5481 18.7535 26.8438 18.8973L28.1142 19.5285V23.3557L25.1179 23.3637V15.166C25.1179 13.568 24.0473 12.769 22.721 12.769H16.329C15.0027 12.769 13.932 13.568 13.932 15.166V28.1497H12.7335C12.4059 28.1497 12.1343 28.4214 12.1343 28.7489C12.1343 29.0765 12.4059 29.3482 12.7335 29.3482H26.3164C26.644 29.3482 26.9157 29.0765 26.9157 28.7489C26.9157 28.4214 26.644 28.1497 26.3164 28.1497H25.1179V24.5622L28.7134 24.5542C29.049 24.5542 29.3127 24.2826 29.3127 23.955V19.161C29.3127 18.9373 29.1848 18.7295 28.9851 18.6257ZM15.9295 16.6761C15.9295 15.5655 16.6086 15.166 17.4396 15.166H21.6183C22.4413 15.166 23.1205 15.5655 23.1205 16.6761V17.6589C23.1205 18.7615 22.4413 19.161 21.6104 19.161H17.4396C16.6086 19.161 15.9295 18.7615 15.9295 17.6509V16.6761ZM16.329 20.9587H18.726C19.0536 20.9587 19.3252 21.2304 19.3252 21.558C19.3252 21.8856 19.0536 22.1572 18.726 22.1572H16.329C16.0014 22.1572 15.7298 21.8856 15.7298 21.558C15.7298 21.2304 16.0014 20.9587 16.329 20.9587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceYellowIcon);
export default __webpack_public_path__ + "static/media/deviceYellowIcon.e1fdaf4ff1d04f1321c802cbada71985.svg";
export { ForwardRef as ReactComponent };